import { render, staticRenderFns } from "./HeroPlaceholder.vue?vue&type=template&id=56e93d0a"
import script from "./HeroPlaceholder.vue?vue&type=script&lang=js"
export * from "./HeroPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports